import type { ReactNode } from "react";

/**
 * Baseline shell for a "system" page (Tokens, and eventually Settings, etc.).
 *
 * The app's three-column layout — file tree (left), header (top), right sidebar
 * — stays put for these pages (see App.tsx: only `/_data` goes full-bleed). A
 * system page fills only the MIDDLE column. This component is that middle: a
 * title, an optional lead line, and `SystemSection` blocks, so every system
 * page reads the same.
 */
export function SystemPage({
  title,
  lead,
  className,
  children,
}: {
  title: string;
  lead?: ReactNode;
  /** Extra class on the wrapper, e.g. a page keeping its own scoped CSS. */
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={`dw-doc dw-system${className ? ` ${className}` : ""}`}>
      <h1>{title}</h1>
      {lead && <p className="dw-system-lead">{lead}</p>}
      {children}
    </div>
  );
}

/** A titled section within a system page. */
export function SystemSection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <section className="dw-system-section">
      <h2>{title}</h2>
      {children}
    </section>
  );
}
